import React from 'react';
import { ContentBoxContainer, ContentBoxText, ContentBoxFigure, Spacer, PenlySeo } from 'components';

export default function Kontakt() {
    const description = 'Kontakt Penly - Teal ApS, Glasvej 3, 1. 2400 København NV';
    const image = { url: '/static/gfx/content/penly-content-5.jpg' };
    return (
        <>
            <PenlySeo title={ 'Kontakt Penly' } description={ description } image={ image } />
            <ContentBoxContainer className="mobileflip">
                <ContentBoxText>
                    <div className="large">
                        <h6>Kontakt vores kundeservice</h6>
                        Telefon: <a href="tel:+4593838372">+45 93 83 83 72</a><br/>
                        Du kan ringe til os tirsdag og torsdag mellem 10.00 og 14.00.<br />
                        <br />
                        E-mail: <a href="mailto:kontakt@penly.dk">kontakt@penly.dk</a>
                    </div>
                    <h6>Adresse</h6>
                    <p>
                        Teal ApS, Symbion<br />
                        Fruebjergvej 3<br />
                        2100 København Ø
                    </p>
                </ContentBoxText>
                <ContentBoxFigure className="brtl topSpace" figure={ image.url }></ContentBoxFigure>
            </ContentBoxContainer>
        </>
    );
}
